import { render, staticRenderFns } from "./indexManage.vue?vue&type=template&id=193ed736&scoped=true"
import script from "./indexManage.vue?vue&type=script&lang=js"
export * from "./indexManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193ed736",
  null
  
)

export default component.exports